import { WINDOW_OPTIONS_HOURS } from '../config.js';
import { fromCompact, MS_PER_HOUR, toCompact } from '@meteoradar/shared/time';

export const readFrameParam = (search: string): Date | null => {
  const raw = new URLSearchParams(search).get('t');
  return raw === null ? null : fromCompact(raw);
};

export const windowHoursFor = (target: Date, now: Date, current: number): number => {
  const needed = (now.getTime() - target.getTime()) / MS_PER_HOUR;
  if (needed <= current) {
    return current;
  }
  return WINDOW_OPTIONS_HOURS.find(hours => hours >= needed) ?? WINDOW_OPTIONS_HOURS.at(-1) ?? current;
};

export const frameParam = (iso: string): string => toCompact(new Date(iso));

export const withFrameParam = (search: string, iso: string | null): string => {
  const params = new URLSearchParams(search);
  if (iso === null) {
    params.delete('t');
  } else {
    params.set('t', frameParam(iso));
  }
  const text = params.toString();
  return text === '' ? '' : `?${text}`;
};
